"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableBodyEmpty = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var aapn_icons_styles_1 = require("../../LoadingSpinners/aapn_icons.styles");
var storm_ui_1 = require("@amzn/storm-ui");
var EmptyResultsContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 300px;\n  border: 1px solid ", ";\n  border-top: none;\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n"], ["\n  height: 300px;\n  border: 1px solid ", ";\n  border-top: none;\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.mercury;
});
var TableBodyEmpty = function (props) {
    if (props.loading) {
        return (react_1.default.createElement(EmptyResultsContainer, null,
            react_1.default.createElement(storm_ui_1.Text, { type: 'h3', withMargin: true },
                react_1.default.createElement(aapn_icons_styles_1.RotatingFontAwesomeIcon, { "aria-busy": true, "aria-label": props.loadingText, icon: { prefix: 'fas', iconName: 'spinner' }, size: '2x' }))));
    }
    else if (props.error) {
        return (react_1.default.createElement(EmptyResultsContainer, null,
            react_1.default.createElement(storm_ui_1.Text, { type: 'h3', withMargin: true }, props.errorText),
            react_1.default.createElement(storm_ui_1.Text, null, props.searchAgainText)));
    }
    return (react_1.default.createElement(EmptyResultsContainer, null,
        react_1.default.createElement(storm_ui_1.Text, { type: 'h3', withMargin: true }, props.noResultsText),
        react_1.default.createElement(storm_ui_1.Text, null, props.searchAgainText)));
};
exports.TableBodyEmpty = TableBodyEmpty;
var templateObject_1;
